import React from 'react'
import Navbar from './Navbar'

const Layout = (props) => {

    return (
        <>
            <div id="viewport">
                <Navbar />
                <div id="content">
                    <div id="content_box">
                        {props.children}
                    </div>
                </div>
            </div>

        </>
    )
}

export default Layout